
import { initializeApp } from "firebase/app";
import { isProduction } from "./components/utils";

const firebaseConfigProd = {
    apiKey: "AIzaSyAdKSkRDEAMnitjc91kM9L7xI-a6fSN7O0",
    authDomain: "la-caja-boba-d3526.firebaseapp.com",
    projectId: "la-caja-boba-d3526",
    storageBucket: "la-caja-boba-d3526.appspot.com",
    messagingSenderId: "340484192866",
    appId: "1:340484192866:web:eb5df9bec4232c6b8e2f3b",
    measurementId: "G-YLF05H2HX1"
};

const firebaseConfigDev = {
    apiKey: "AIzaSyDwNDFrkLes2vscGOGFMnbdrXalnhGeOo8",
    authDomain: "casita-b7d81.firebaseapp.com",
    databaseURL: "https://casita-b7d81-default-rtdb.firebaseio.com",
    projectId: "casita-b7d81",
    storageBucket: "casita-b7d81.appspot.com",
    messagingSenderId: "98983378357",
    appId: "1:98983378357:web:173fe784fbc1c8ffa7adfc"
};

export const app = initializeApp(isProduction() ? firebaseConfigProd : firebaseConfigDev);
